import React, { useReducer, useEffect, useState, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  HeaderFilter,
  RequiredRule,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import { NumberBox } from "devextreme-react/number-box";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import { CONFIG } from "./config";
import { Button } from "devextreme-react/button";

import ShiftManager from "../shiftManager/ShiftScheduler";

import { alert } from "devextreme/ui/dialog";
import AsyncCallHandler from "../../common/AsyncCallHandler";
import NEXUS_CONST from "../../common/constants";
import { postUserLog } from "../../actions/common";
import { getUpdatedRecord } from "../../common/utils";
import { confirm } from "devextreme/ui/dialog";
import config from "../../common/config";
import {
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
} from "../../common/utils";

const initialState = {
  tiersData: [],
  tiersAboveData: [],
  LinesData: [],
  userPrefSettings: null,
};

export default ({ siteId, tierId }) => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  const [activTier, setActiveTier] = useState(0);
  const [activTierName, setActiveTierName] = useState(0);
  const [parentTier, SetParentTier] = useState(0);
  const [filteredLines, setFilteredLines] = useState([]);
  const [LinesData, SetLinesData] = useState([]);
  const [activeLine, SetActiveLine] = useState(0);
  const dataGridRef = useRef(null);

  let { tiersData, tiersAboveData, userPrefSettings } = state;
  const loggedinUser = get("hid");
  const widgetId = "manageTiers";
  const GRID_COLS = JSON.stringify([
    "tierID",
    "tierName",
    "tierLevel",
    "nextTierID",
    "duration",
    "sliderDuration",
    "isAutomated",
    "isSubTier",
    "lineID",
  ]);

  useEffect(() => {
    actions.fetchUserPref(
      dispatch,
      `=0&SiteUID=${siteId}&widgetID=${widgetId}`
    );
    return () => {
      actions.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId,
          tierId: 0,
          moduleName: widgetId,
          loggedinUser,
          prefSess: "userPrefSettings",
          GRID_COLS,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPrefSettings) set("userPrefSettings", userPrefSettings);
    if (
      dataGridRef &&
      dataGridRef.current &&
      dataGridRef.current.instance !== null &&
      userPrefSettings &&
      tiersData
    ) {
         applyUserPref(dataGridRef, userPrefSettings);
    }
  }, [tiersData, tiersAboveData, userPrefSettings]);

  useEffect(() => {
    AsyncCallHandler(NEXUS_CONST.GET_SITE_LINES + siteId, NEXUS_CONST.GET).then(
      (res) => {
        if (res.data) {
          SetLinesData(res.data);
        }
      }
    );

    actions.fetchTiers(dispatch, siteId);
    actions.fetchTiersAbove(dispatch, siteId);
  }, []);
  useEffect(() => {
    setFilteredLines(
      tiersData.filter((tier) => tier.lineID !== 0).map((tier) => tier.lineID)
    );
  }, [tiersData]);

  const onRowUpdating = (data) => {
    let oldData = data.oldData;
    let newData = data.newData;

    let diffVal = getUpdatedRecord(oldData, newData);

    let {
      tierID,
      tierName,
      tierLevel,
      duration,
      sliderDuration,
      nextTierID,
      isAutomated,
      lineID,
      isSubTier,
    } = newData;

    let input = {
      tierID: tierID != undefined ? tierID : oldData.tierID,
      tierName: tierName != undefined ? tierName : oldData.tierName,
      tierLevel: tierLevel != undefined ? tierLevel : oldData.tierLevel,
      meetingduration:
        duration != undefined
          ? duration.toString()
          : oldData.duration.toString(),
      siteId: siteId,
      sliderDuration:
        sliderDuration != undefined ? sliderDuration : oldData.sliderDuration,
      nextTierID: nextTierID != undefined ? nextTierID : oldData.nextTierID,
      isAutomated:
        lineID === 0
          ? false
          : isAutomated != undefined
          ? isAutomated
          : oldData.isAutomated,
      LineID: lineID != undefined ? lineID : oldData.lineID,
      LoginID: loggedinUser,
      isSubTier: isSubTier,
    };

    let maxTierLevel = Math.max(...tiersData.map((o) => o.tierLevel));

    if (tiersData.filter((ele) => ele.tierLevel == maxTierLevel).length > 1) {
      alert(
        "Tier Level " +
          maxTierLevel +
          " already exists. Please choose a lower tier ",
        "Alert"
      );
    } else {
      Object.keys(diffVal).map((v) => {
        postUserLog({
          event: "Tier Update",
          data: {
            action: `Updated ${v.toUpperCase()} from ${diffVal[v].oldV} to ${
              diffVal[v].newV
            } of ${input.tierName} user.`,
            module: "Settings",
            section: "Manage Tier",
            siteUId: siteId,
            widget: "",
          },
        });
      });
      actions.updateTiers(dispatch, input, siteId);
    }
  };

  const getFilteredTier = (tiersData) => {
    let mapData = [];
    if (tiersData && tiersData.length > 0) {
      let i = 1;
      let maxTierLevel = Math.max(...tiersData.map((o) => o.tierLevel));
      for (i = maxTierLevel; i > 0; i--) {
        var obj = { tierlevel: i };
        mapData.push(obj);
      }

      return mapData;
    }
  };

    function getParentAboveTier(options) {
    if (tiersAboveData) {
      return {
        store: tiersAboveData,
        filter:
          options.data && options.data.tierLevel < 4
            ? [
                ["tierLevel", ">", options.data.tierLevel],
                "and",
                ["tierLevel", "<=", 4],
              ]
            : options.data && options.data.tierLevel >= 4
            ? [
                ["tierLevel", ">", options.data.tierLevel],
                "and",
                ["tierLevel", ">", 4],
              ]
            : null,
      };
    }
  }

  const getDisplayExpr = (item) => {
    return item ? `Tier ${item.tierLevel} - ${item.tierName}` : "";
  };

  const onRowInserted = (data) => {
    let {
      tierName,
      tierLevel,
      duration,
      sliderDuration,
      nextTierID,
      isAutomated,
      lineID,
      isSubTier,
    } = data.data;
    let input = {
      tierID: 0,
      tierName: tierName,
      tierLevel: tierLevel,
      meetingduration: duration.toString(),
      siteId: siteId,
      sliderDuration: sliderDuration,
      nextTierID: nextTierID,
      isAutomated: isAutomated,
      LineID: lineID,
      LoginID: loggedinUser,
      isSubTier: isSubTier,
    };
    let maxTierLevel = Math.max(...tiersData.map((o) => o.tierLevel));
    if (tierLevel === maxTierLevel) {
      alert(
        "Tier Level " +
          maxTierLevel +
          " already exists. Please choose a lower tier ",
        "Alert"
      );
    } else {
      postUserLog({
        event: "Tier Create",
        data: {
          action: `${data.data.tierName} got added`,
          module: "Settings",
          section: "Manage Tier",
          siteUId: siteId,
          widget: "",
        },
      });
      actions.updateTiers(dispatch, input, siteId);
    }
  };

  const onRowRemoved = (data) => {
    postUserLog({
      event: "Tier Delete",
      data: {
        action: `${data.data.tierName} got deleted`,
        module: "Settings",
        section: "Manage Tier",
        siteUId: siteId,
        widget: "",
      },
    });
    let maxTierLevel = Math.max(...tiersData.map((o) => o.tierLevel));
    // if (tierLevel === maxTierLevel) {
    // }
    {
      actions.deleteTier(dispatch, data.data.tierID, siteId);
    }
  };
  const onInitNewRow = (e) => {
    e.data.isAutomated = false;
  };

  const onEditCanceling = (e) => {
    setFilteredLines(
      tiersData.filter((tier) => tier.lineID !== 0).map((tier) => tier.lineID)
    );
  };
  const handlers = {
    onRowRemoved: onRowRemoved,
    onRowInserted: onRowInserted,
    onInitNewRow: onInitNewRow,
    onEditCanceling: onEditCanceling,
  };

  const cellEditFileUploader = (e) => {
    return (
      <div
        className="slider-time-edit"
        style={{ display: "flex", "justify-content": "flex-end" }}
      >
        <NumberBox
          width="70px"
          defaultValue={(e.data.value && e.data.value.minute) || "00"}
          min={0}
          max={59}
          stylingMode="outlined"
          showSpinButtons={true}
          onValueChanged={(ev) => {
            let val = e.data.data;
            val["minute"] = ev.value;
            e.data.setValue(val);
          }}
        />
        <span style={{ padding: "10px 0px" }}>:</span>
        <NumberBox
          width="70px"
          stylingMode="outlined"
          defaultValue={(e.data.value && e.data.value.second) || "00"}
          min={0}
          max={59}
          showSpinButtons={true}
          onValueChanged={(ev) => {
            let val = e.data.data;
            val["second"] = ev.value;
            e.data.setValue(val);
          }}
        />
      </div>
    );
  };

  const cellRender = (e) => {
    if (e.value) {
      let mm = e.value.minute < 9 ? "0" + e.value.minute : e.value.minute;
      let ss = e.value.second < 9 ? "0" + e.value.second : e.value.second;
      return (mm || "00") + ":" + (ss || "00");
    }
  };
  const [shiftMgr, setShiftMgr] = useState(false);

  const shiftScheduleCellRender = (e) => {
    if (e.data.tierLevel == 1 && e.data.tierID !== undefined) {
      return (
        <>
          <Button
            text="Launch"
            onClick={() => {
              setActiveTier(e.data.tierID);
              setActiveTierName(e.data.tierName);
              SetParentTier(e.data.nextTierID);
              setShiftMgr(true);
              SetActiveLine(e.data.lineID);
            }}
            type="default"
            height="25px"
            stylingMode="contained"
          />
        </>
      );
    }
  };

  const oneditorPrepared = (e) => {
    if (e.dataField === "lineID" && e.parentType === "dataRow") {
      let grid = e.component;
      let index = e.row.rowIndex;
      let value = grid.cellValue(index, "isEditable");
      if (!value)
        e.editorOptions.disabled =
          !e.row.data.isAutomated ||
          e.row.data.tierLevel !== 1 ||
          (e.row.data.tierLevel === 1 &&
            e.row.data.isAutomated &&
            e.row.data.lineID !== 0);

      if (filteredLines) {
        if (
          filteredLines.includes(e.editorOptions.value) ||
          e.editorOptions.value === 0
        ) {
          e.editorOptions.value = "";
        }

        e.editorOptions.dataSource = LinesData.filter(
          ({ lineID }) => !filteredLines.includes(lineID)
        );
      }
    } else if (e.dataField === "isAutomated" && e.parentType === "dataRow") {
      let grid = e.component;
      let index = e.row.rowIndex;
      let value = grid.cellValue(index, "isEditable");
      let value1 = grid.cellValue(index, "isAutomated");

      if (!value)
        e.editorOptions.disabled =
          e.row.data.tierLevel !== 1 ||
          (e.row.data.tierLevel === 1 && e.row.data.isAutomated);
    } else if (e.dataField === "isSubTier" && e.parentType === "dataRow") {
      let grid = e.component;
      let index = e.row.rowIndex;
      let value = grid.cellValue(index, "isEditable");
      if (!value) e.editorOptions.disabled = e.row.data.tierLevel !== 1;
    } else {
      return;
    }
  };

  function setStateValue(rowData, value) {
    this.defaultSetCellValue(rowData, value);
    let prevValue = filteredLines;
    prevValue.push(value);
    setFilteredLines(prevValue);
  }
  function setAutomatedStateValue(rowData, value, currentRowData) {
    if (value) {
      rowData.isAutomated = value;
      alert(
        "Checking this box will restrict data entry to the tier. If the tier is to be changed to a manual line then please use the Undo icon before clicking on save"
      );
    } else {
      rowData.isAutomated = value;
    }
    this.defaultSetCellValue(rowData, value);
  }
  const customizeExportData = (columns, rows) => {
    //Iterate through rows and customize the data in the problematic column
    rows.forEach((row) => {
      // Customize slider column name if we are adding extra columns we should match with it
      const columnNameValue = row.data.sliderDuration;

      let mm =
        columnNameValue.minute < 9
          ? "0" + columnNameValue.minute
          : columnNameValue.minute;
      let ss =
        columnNameValue.second < 9
          ? "0" + columnNameValue.second
          : columnNameValue.second;

      let findIndex = row.values.findIndex(
        (x) => x !== null && typeof x === "object"
      );
      // Transform the object into a string
      if (findIndex !== -1)
        row.values[findIndex] = (mm || "00") + ":" + (ss || "00");
    });
  };
  // Define a function to calculate the cell value conditionally
  const calculateIsActiveCellValue = (row) => {
    // Check the value of the isActive property
    if (row.isAutomated) {
      return "Active";
    } else {
      return "Inactive";
    }
  };

  return (
    <div>
      <DataGrid
        dataSource={tiersData}
        allowColumnReordering={true}
        showBorders={true}
        {...CONFIG.TIERS_GRID}
        {...handlers}
        onEditorPreparing={oneditorPrepared}
        customizeExportData={customizeExportData}
        onRowUpdating={onRowUpdating}
        ref={dataGridRef}
        onContentReady={(e) => setGridUserPrefs(e, widgetId)}
        onColumnsChanging={(e) => setGridWidthPrefs(e, widgetId)}
      >
        <Paging defaultPageSize={5} />
        <Pager
          visible={true}
          allowedPageSizes={[5, 10, 20, 50]}
          showPageSizeSelector={true}
          showInfo={true}
          showNavigationButtons={true}
        />
        <Column
          {...{
            dataField: "tierID",
            caption: "Tier ID",
            dataType: "number",
            width: 200,
            allowEditing: false,
          }}
        />
        <Column
          {...{
            dataField: "tierName",
            caption: "Tier Name",
            validationRules: [
              {
                type: "required",
              },
            ],
          }}
        />
        <Column
          {...{
            dataField: "tierLevel",
            caption: "Tier Level",
            width: 200,
            validationRules: [
              {
                type: "required",
              },
                      ],
                      headerFilter:
                          {
                              dataSource: function (options) {
                  options.dataSource.postProcess = function (results) {
                      return results.filter((item) => item.value !== null);;
                  }
              }
                          }}
          }
        
        >
          <Lookup
            dataSource={getFilteredTier(tiersData)}
            valueExpr="tierlevel"
            displayExpr="tierlevel"
          />
        </Column>
        <Column
          {...{
            dataField: "nextTierID",
            caption: "Parent Tier",
            width: 200,
                  }}

            headerFilter={{
                    dataSource: function (options) {
                        let isEmptyExist = tiersData.findIndex(d => d.nextTierID == 0)
                        if (isEmptyExist > -1) {
                            options.dataSource.postProcess = function (results) {
                                return results.map((item) => {
                                    if (item.value == null) item.value = 0;
                                    return item;
                                });
                            }
                        } else {
                            options.dataSource.postProcess = function (results) {
                                return results.filter((item) => item.value !== null);
                            }
                        }
                    }
                }}
        >
          <Lookup
            dataSource={getParentAboveTier}
            valueExpr="tierID"
            displayExpr={getDisplayExpr}
          />
        </Column>

        <Column
          {...{
            dataField: "duration",
            caption: "Digital Tier Duration(Mins.)",
            dataType: "number",
            maxLength: 2,
            width: 250,
            validationRules: [
              {
                type: "required",
                message: "Duration is required",
              },
              {
                type: "range",
                max: 60,
                message: "Minutes must be less than 60",
              },
            ],
          }}
        />
        <Column
          {...{
            dataField: "sliderDuration",
            caption: "Slider Duration(MM:SS)",
            allowEditing: true,
            editorOption: { allowEditing: true },
            dataType: "number",
            visible: true,
          }}
          editCellComponent={cellEditFileUploader}
          cellRender={cellRender}
          allowHeaderFiltering={false}
          allowFiltering={false}
          allowSorting={false}
        />

        { config.DEV_DISPLAY_OPTIONS && <Column
          dataField="isAutomated"
          caption="Automated Line"
          dataType="boolean"
          //calculateCellValue={calculateIsActiveCellValue}
          setCellValue={setAutomatedStateValue}
          // allowEditing={(data) => !data.isAutomated}
        >
          <HeaderFilter dataSource={CONFIG.ISAUTOMATEDLINE} />
        </Column> }

        { config.DEV_DISPLAY_OPTIONS && <Column
          dataField="isSubTier"
          caption="Sub Tier"
          dataType="boolean"
          allowEditing="true"
          visible={false}
        ></Column> }

        { config.DEV_DISPLAY_OPTIONS && <Column
          dataField="lineID"
          caption="Line Selection"
          setCellValue={setStateValue}
          headerFilter={{
                    dataSource: function (options) {
                    let isEmptyLine = tiersData.findIndex(d => d.lineID == 0)
                        if (isEmptyLine > -1) {
                            options.dataSource.postProcess = function (res) {
                                return res.map((item) => {
                                    if (item.value == null) item.value = 0;
                                    return item;
                                });
                            }
                        } else {
                            options.dataSource.postProcess = function (opt) {
                                return opt.filter((d) => d.value !== null);
                            }
                        }
                    }
                }}
        >
          <Lookup
            dataSource={LinesData}
            valueExpr="lineID"
            displayExpr="line"
          />
        </Column> }
        <Column
          caption="Shift Schedule"
          cellRender={shiftScheduleCellRender}
          width="120px"
        />
      </DataGrid>
      {shiftMgr && (
        <ShiftManager
          siteId={siteId}
          tierId={activTier}
          closeShift={(d) => setShiftMgr(d)}
          tierName={activTierName}
          activeLine={activeLine}
          parentTier={parentTier}
        />
      )}
    </div>
  );
};
